enum FeatureFlag {
    Accounting = 'accounting',
    CostPrice = 'cost_price',
    Dispatch = 'dispatch',
    GenerateLabelsNew = 'generate_labels_new',
    Receiving = 'receiving',
}

export default FeatureFlag;
